const baseSchema = {
  type: "object",
  properties: {
    eventId: { type: "number" },
    name: { type: "string", minLength: 1 },
    backgroundKey: { type: "string" },
    documentData: {
      type: "object",
      properties: {
        documentSize: { type: "string" },
        hasBackground: { type: "boolean" },
        fields: {
          type: "array",
          items: {
            type: "object",
            properties: {
              name: { type: "string", minLength: 1 },
              xPct: { type: "number", minimum: 0, maximum: 100 },
              yPct: { type: "number", minimum: 0, maximum: 100 },
              widthPct: { type: "number", minimum: 0, maximum: 100 },
              heightPct: { type: "number", minimum: 0, maximum: 100 },
              fontSize: { type: "number", minimum: 0 },
              color: {
                type: "string",
                pattern: "^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$",
              },
              align: { type: "string", enum: ["left", "center", "right"] },
            },
            required: [
              "name",
              "xPct",
              "yPct",
              "widthPct",
              "heightPct",
              "fontSize",
              "color",
              "align",
            ],
          },
        },
      },
      required: ["documentSize", "hasBackground", "fields"],
    },
  },
  required: ["eventId", "name"],
};

export const createDocumentTemplateSchema = {
  body: baseSchema,
};

export const web_createDocumentTemplateSchema = {
  type: "object",
  properties: {
    eventId: { type: "number" },
    name: { type: "string", minLength: 1 },
  },
  required: ["eventId", "name"],
};

export const getDocumentTemplateSchema = {
  params: {
    type: "object",
    properties: {
      id: { type: "number" },
    },
    required: ["id"],
  },
};

export const getDocumentTemplatesSchema = {
  querystring: {
    type: "object",
    properties: {
      eventId: { type: "number" },
      page: { type: "number" },
      limit: { type: "number" },
    },
    required: ["eventId"],
  },
};

export const distributeDocumentSchema = {
  params: {
    type: "object",
    properties: {
      id: { type: "number" },
    },
    required: ["id"],
  },
  body: {
    type: "object",
    properties: {
      tagId: { type: "number" },
      shouldCreateAnnouncement: { type: "boolean" },
      shouldEmailRecipients: { type: "boolean" },
    },
  },
};

export const getDistributePreviewSchema = {
  params: {
    type: "object",
    properties: {
      id: { type: "number" },
    },
    required: ["id"],
  },
  querystring: {
    type: "object",
    properties: {
      tagId: { type: "number" },
    },
  },
};

export const updateDocumentTemplateSchema = {
  params: {
    type: "object",
    properties: {
      id: { type: "number" },
    },
    required: ["id"],
  },
  body: {
    ...baseSchema,
    required: [],
  },
};

export const deleteDocumentTemplateSchema = {
  body: {
    type: "object",
    properties: {
      id: { type: "number" },
    },
    required: ["id"],
  },
};
